<template>
  <div class="create-company-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span
          ><i class="el-icon-office-building"></i>Create company by Modulr</span
        >
      </div>
      <el-form
        :model="companyForm"
        id="companyForm"
        ref="companyForm"
        label-width="180px"
        size="small"
        :label-position="device === 'mobile' ? 'top' : 'right'"
      >
        <el-alert v-if="errMsg" :title="errMsg" type="error" show-icon>
        </el-alert>
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-card class="card card-director-form" shadow="never">
              <div slot="header" class="clearfix">
                <span>Company</span>
              </div>
              <div>
            <el-form-item
              prop="company.name"
              label="Company Name"
              :rules="companyRules.company.name"
            >
              <el-input v-model="companyForm.company.name"></el-input>
            </el-form-item>

            <el-form-item
              prop="company.typeOfBusiness"
              label="Type Of Business"
              :rules="companyRules.company.typeOfBusiness"
            >
              <!-- <el-input v-model="companyForm.company.typeOfBusiness"></el-input> -->
              <el-select
                v-model="companyForm.company.typeOfBusiness"
                placeholder="Select type of business"
                
              >
                <el-option
                  v-for="item in typeOfBusinessList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            
            <el-form-item
              prop="company.registrationNumber"
              label="Registration Number"
              :rules="companyRules.company.registrationNumber"
            >
              <el-input
                v-model="companyForm.company.registrationNumber"
              ></el-input>
            </el-form-item>

            <el-form-item 
              prop="company.industryCode" 
              label="Industry Code"
              :rules="companyRules.company.industryCode"
            >
              <el-select
                v-model="companyForm.company.industryCode"
                filterable
                remote
                reserve-keyword
                placeholder="Please enter a keyword industry"
                :remote-method="searchIndustrial"
                :loading="loading"
                style="width:100%"
              >
                <el-option
                  v-for="item in industryOptions"
                  :key="item.code"
                  :label="`${item.code} : ${item.detail}`"
                  :value="item.section"
                  
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="company.legalEntity"
              label="Legal Entity"
              :rules="companyRules.legalEntity"
            >
              <!-- <el-input v-model="companyForm.company.typeOfBusiness"></el-input> -->
              <el-select
                v-model="companyForm.legalEntity"
                placeholder="Select Legal Entity"
              >
                <el-option label="GB" value="GB"></el-option>
                <el-option label="IE" value="IE"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              prop="company.tcsVersion"
              label="TSC Version"
            >
              <!-- <el-input v-model="companyForm.company.typeOfBusiness"></el-input> -->
              <el-select v-model="companyForm.company.tcsVersion" placeholder="Select TSC Version">
              <el-option
                v-for="item in [ 1, 2, 3, 4, 5 ]"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
            </el-form-item>

            <el-form-item
              prop="company.expectedMonthlySpend"
              label="Expected Monthly Spend"
              :rules="companyRules.company.expectedMonthlySpend"
            >
              <el-input type="number"
                v-model="companyForm.company.expectedMonthlySpend"
              ></el-input>
            </el-form-item>

            <el-form-item prop="company.addressnumber" label="Address number" :rules="companyRules.company.addressnumber">
              <el-input v-model="companyForm.company.addressnumber"></el-input>
            </el-form-item>

            <el-form-item prop="company.street" label="Street" :rules="companyRules.company.street">
              <el-input v-model="companyForm.company.street"></el-input>
            </el-form-item>

            <el-form-item prop="company.city" label="City" :rules="companyRules.company.city">
              <el-input v-model="companyForm.company.city"></el-input>
            </el-form-item>

            <el-form-item prop="company.zipcode" label="Zipcode" :rules="companyRules.company.zipcode">
              <el-input v-model="companyForm.company.zipcode"></el-input>
            </el-form-item>

            <el-form-item prop="company.countrycode" label="Country code" :rules="companyRules.company.countrycode">
              <el-autocomplete
                class="inline-input"
                v-model="companyForm.company.countrycode"
                :fetch-suggestions="querySearchCountrycode"
                @select="selectCompanyCountrycode"
                :maxlength="2"
              >
                <template slot-scope="{ item }">
                  <div>{{ item.country_code }} - {{ item.country_name }}</div>
                </template>
              </el-autocomplete>
            </el-form-item>

              </div>
            </el-card>
          </el-col>

          <!--//////////////////////// Director //////////////////////////-->

          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="(item, index) in companyForm.associates" :key="index">
            <el-card class="card card-director-form" shadow="never">
              <div slot="header" class="clearfix">
                <span>{{ (item.position && item.position.replace("_", " ")) || 'NEW DIRECTOR'}}</span>
                <div style="float: right; padding: 3px 0">
                  <el-button type="success" icon="el-icon-plus" size="mini" circle @click="addDirector()"></el-button>
                  <el-button type="danger" icon="el-icon-delete" size="mini" circle v-if="!item.applicant && ![0, 1].includes(index)" @click="removeDirector(index)"></el-button>
                </div>
              </div>
              <div>
                <el-form-item label="First Name" 
                :prop="`associates[${index}].firstName`"
                :rules="companyRules.associates.firstName">
                  <el-input v-model="companyForm.associates[index].firstName"></el-input>
                </el-form-item>

                <el-form-item label="Last Name" 
                  :prop="`associates[${index}].lastName`"
                  :rules="companyRules.associates.lastName">
                    <el-input v-model="companyForm.associates[index].lastName"></el-input>
                </el-form-item>

                <el-form-item
                  :prop="`associates[${index}].position`"
                  label="Position"
                  :rules="companyRules.associates.position"
                >
                  <el-select v-model="companyForm.associates[index].position" 
                    placeholder="Select Position"
                    :disabled="[0, 1].includes(index) "
                    >
                    <el-option
                      v-for="(item, index) in directorPositionList"
                      :key="index"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Email" 
                  :prop="`associates[${index}].email`"
                  :rules="companyRules.associates.email">
                    <el-input v-model="companyForm.associates[index].email"></el-input>
                </el-form-item>

                <el-form-item label="Date of Birth" 
                  :prop="`associates[${index}].dateOfBirth`"
                  :rules="companyRules.associates.dateOfBirth">
                    <!-- <el-input v-model="companyForm.associates[index].dateOfBirth"></el-input> -->
                    <el-date-picker
                      v-model="companyForm.associates[index].dateOfBirth"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="Choose date of birth">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="Telephone" 
                  :prop="`associates[${index}].telephone`"
                  :rules="companyRules.associates.telephone">
                    <el-input v-model="companyForm.associates[index].telephone"></el-input>
                </el-form-item>

                <el-form-item label="Address number" 
                  :prop="`associates[${index}].addressnumber`"
                  :rules="companyRules.associates.addressnumber">
                    <el-input v-model="companyForm.associates[index].addressnumber"></el-input>
                </el-form-item>

                <el-form-item label="Street" 
                  :prop="`associates[${index}].street`"
                  :rules="companyRules.associates.street">
                    <el-input v-model="companyForm.associates[index].street"></el-input>
                </el-form-item>

                <el-form-item label="City" 
                  :prop="`associates[${index}].city`"
                  :rules="companyRules.associates.city">
                    <el-input v-model="companyForm.associates[index].city"></el-input>
                </el-form-item>

                <el-form-item label="Country Code" 
                  :prop="`associates[${index}].countrycode`" 
                  :rules="companyRules.associates.countrycode">
                    <!-- <el-input v-model="companyForm.associates[index].countrycode"></el-input> -->
                    <el-autocomplete
                      class="inline-input"
                      v-model="companyForm.associates[index].countrycode"
                      :fetch-suggestions="querySearchCountrycode"
                      @select="selectDirectorCountrycode($event, index)"
                      :maxlength="2"
                    >
                      <template slot-scope="{ item }">
                        <div>{{ item.country_code }} - {{ item.country_name }}</div>
                      </template>
                    </el-autocomplete>
                </el-form-item>

                <el-form-item label="Zipcode" 
                  :prop="`associates[${index}].zipcode`"
                  :rules="companyRules.associates.zipcode">
                    <el-input v-model="companyForm.associates[index].zipcode"></el-input>
                </el-form-item>

                <el-form-item label="Ownership" 
                  :prop="`associates[${index}].ownership`"
                  :rules="companyRules.associates.ownership"
                  v-if="companyForm.associates[index].position == 'BENE_OWNER'"
                  >
                    <el-input type="number" v-model="companyForm.associates[index].ownership">
                      <template slot="append">%</template>
                    </el-input>
                </el-form-item>
              </div>
            </el-card>


          </el-col>
        </el-row>
      </el-form>
      <div class="footer text-center">
        <el-button type="primary" :loading="submiting" @click="submitCompany()"
          >Submit</el-button
        >
        <el-button @click="resetForm" type="warning">Reset</el-button>
        <el-button @click="cancelForm">Cancel</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import model from "../models/vender-modulr-model";
import { getUtility } from "@/api/customer";
import { createCompany } from "@/api/company";
import { getIndustrialCodes } from "@/api/utility";
import { dateFormat } from '@/utils'
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  data() {
    return {
      loading: false,
      submiting: false,
      errMsg: "",
      utility: {},
      industryOptions: [],
      companyForm: model.getCompanyForm(),
      companyRules: model.getCompanyRulesForm(),
      typeOfBusinessList: model.getTypeOfBusinessList(),
      directorPositionList: model.getDirectorPositionList(),
    };
  },
  methods: {
    getUtility() {
      getUtility().then(({ result, data }) => {
        if (result) {
          this.utility = data;
        }
      });
    },
    cancelForm() {
      this.$router.push("/company");
    },
    resetForm() {
      if (this.$refs.companyForm) this.$refs.companyForm.resetFields();
    },
    addDirector(){
      this.companyForm.associates.push({
        applicant: false,
        dateOfBirth: "",
        email: "",
        firstName: "",
        lastName: "",
        position: "",
        telephone: "",
        addressnumber: "",
        street: "",
        city: "",
        countrycode: "",
        zipcode: "",
        ownership: 0
      });
    },
    removeDirector(index){
      this.companyForm.associates.splice(index, 1);
    },
    querySearchCountrycode(queryString, cb) {
      var data = this.utility.country;
      var results = queryString
        ? data.filter(this.createFilter(queryString, "country_code"))
        : data;

      cb(results);
    },
    selectDirectorCountrycode(item, index) {
      this.companyForm.associates[index].countrycode = item.country_code;
    },
    selectCompanyCountrycode(item) {
      this.companyForm.company.countrycode = item.country_code;
    },
    createFilter(queryString, key) {
      return (item) => {
        return item[key].toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    searchIndustrial(queryString) {
      this.loading = true;
      getIndustrialCodes(queryString).then(({ result, data }) => {
        this.loading = false;
        if (result) {
          this.industryOptions = data;
        }
      });
    },
    getFormData() {
      this.companyForm.associates.forEach((item) => {
        item.dateOfBirth = dateFormat(item.dateOfBirth, "YYYY-MM-DD");
      });

      return this.companyForm;
    },
    createCompany() {
      const formData = this.getFormData();
      this.submiting = true;
      this.errMsg = "";
      createCompany(formData).then(({ result, message }) => {
        this.submiting = false;
        if (result) {
          this.$confirm('Create Company successfully', 'Successfully', {
            confirmButtonText: 'OK',
            showCancelButton: false,
            type: 'success',
          }).then(() => {
            this.cancelForm()
          });
        } else {
          this.errMsg = message;
        }
      });
    },
    submitCompany() {
      this.$refs.companyForm.validate((valid) => {
        if (valid) {
          this.createCompany();
        } else {
          this.$alert('Please fill out some field', 'Form Validation Error', {
            confirmButtonText: 'OK',
            type: 'error',
          });
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    this.getUtility();
    this.resetForm();
  }
};
</script>

<style lang="scss">
.create-company-container {
  .el-card__header {
    padding: 8px 10px;
}
  .el-form-item--small.el-form-item {
    margin-bottom: 16px;
  }
  .item__label {
    line-height: 30px;
    font-weight: bold;
  }

  .el-form-item__label {
    font-size: 11px;
  }

  .el-divider__text {
    font-weight: bold;
    font-size: 14px;
    color: #424242;
  }

  .card-director-form{
    margin-bottom: 10px;
  }

  .row-eq-height {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display:         flex;
  }

  .footer {
    border-top: 1px solid #ebeef5;
    padding-top: 20px;
    margin-top: 20px;
    margin-left: -20px;
    margin-right: -20px;
  }
}
</style>